export default function Projects() {
  return (
    <section id="projects" className="fade-in">
      <h2>Projects</h2>
      {/* Terminal Command Header */}
      <div className="terminal-cmd">
        <span className="cmd-prompt">kartik@portfolio</span>
        <span className="cmd-path">:~/projects$</span> ls -la
      </div>
      {/* Project Listing like ls -la */}
      <div className="project-listing">
        <div className="listing-header">
          <span>drwxr-xr-x</span>
          <span>kartik</span>
          <span>devops</span>
          <span>Aug 2025</span>
          <span className="listing-name">./</span>
        </div>
        {/* Project 1 */}
        <div className="project-entry" data-project="eks">
          <span className="entry-permissions">drwxr-xr-x</span>
          <span className="entry-user">kartik</span>
          <span className="entry-group">devops</span>
          <span className="entry-date">Aug 2025</span>
          <span className="entry-name"><i className="fa-solid fa-folder"></i> 3-Tier-EKS-Deployment/</span>
        </div>
        {/* Project 2 */}
        <div className="project-entry" data-project="minidrive">
          <span className="entry-permissions">drwxr-xr-x</span>
          <span className="entry-user">kartik</span>
          <span className="entry-group">cloud</span>
          <span className="entry-date">Sep 2025</span>
          <span className="entry-name"><i className="fa-solid fa-folder"></i> Minidrive-Cloud-Storage/</span>
        </div>
        {/* Project 3 */}
        <div className="project-entry" data-project="terraform">
          <span className="entry-permissions">drwxr-xr-x</span>
          <span className="entry-user">kartik</span>
          <span className="entry-group">infra</span>
          <span className="entry-date">Oct 2025</span>
          <span className="entry-name"><i className="fa-solid fa-folder"></i> Terraform-Multi-Env/</span>
        </div>
      </div>
      {/* Project Details - cat README.md style */}
      <div className="project-details">
        {/* Project 1 Detail */}
        <article className="project-readme" id="project-eks">
          <div className="readme-cmd">
            <span className="cmd-prompt">kartik@portfolio</span>
            <span className="cmd-path">:~/projects/3-Tier-EKS-Deployment$</span> cat README.md
          </div>
          <div className="readme-content">
            <div className="readme-header">
              <h3><i className="fa-solid fa-cube"></i> Automated 3-Tier Deployment on AWS EKS</h3>
              <div className="readme-badges">
                <span className="badge kubernetes">Kubernetes</span>
                <span className="badge aws">AWS</span>
                <span className="badge argocd">ArgoCD</span>
              </div>
            </div>
            <div className="readme-body">
              <p className="readme-desc">End-to-End DevOps pipeline built on AWS with Terraform, Jenkins, SonarQube, ArgoCD, Prometheus, and Grafana. Implements CI/CD, automated security & quality checks, GitOps-based deployments, and real-time monitoring.</p>
              <div className="readme-features">
                <span><i className="fa-solid fa-check"></i> CI/CD Pipeline</span>
                <span><i className="fa-solid fa-check"></i> GitOps</span>
                <span><i className="fa-solid fa-check"></i> Monitoring</span>
                <span><i className="fa-solid fa-check"></i> Auto-scaling</span>
              </div>
            </div>
            <div className="readme-links">
              {/* <a href="http://google.com" target="_blank" className="readme-link demo">
                <i className="fa-solid fa-play"></i> ./demo.sh
              </a> */}
              <a href="https://github.com/KARTIKNAIK18/3-Tier-EKS-Deployment.git" target="_blank" rel="noopener noreferrer" className="readme-link code">
                <i className="fa-brands fa-github"></i> git clone
              </a>
            </div>
          </div>
        </article>
        {/* Project 2 Detail */}
        <article className="project-readme" id="project-minidrive">
          <div className="readme-cmd">
            <span className="cmd-prompt">kartik@portfolio</span>
            <span className="cmd-path">:~/projects/Minidrive-Cloud-Storage$</span> cat README.md
          </div>
          <div className="readme-content">
            <div className="readme-header">
              <h3><i className="fa-solid fa-cloud"></i> Minidrive - Cloud Storage Platform</h3>
              <div className="readme-badges">
                <span className="badge lambda">Lambda</span>
                <span className="badge api">API Gateway</span>
                <span className="badge s3">S3</span>
              </div>
            </div>
            <div className="readme-body">
              <p className="readme-desc">A Django-powered file storage application leveraging AWS serverless architecture with Lambda functions, API Gateway and S3 presigned URLs. Enables secure direct uploads and downloads without server overhead.</p>
              <div className="readme-features">
                <span><i className="fa-solid fa-check"></i> Serverless</span>
                <span><i className="fa-solid fa-check"></i> Secure URLs</span>
                <span><i className="fa-solid fa-check"></i> Django</span>
                <span><i className="fa-solid fa-check"></i> Scalable</span>
              </div>
            </div>
            <div className="readme-links">
              {/* <a href="#" target="_blank" className="readme-link demo">
                <i className="fa-solid fa-play"></i> ./demo.sh
              </a> */}
              <a href="https://github.com/KARTIKNAIK18/Minidrive.git" target="_blank" rel="noopener noreferrer" className="readme-link code">
                <i className="fa-brands fa-github"></i> git clone
              </a>
            </div>
          </div>
        </article>
        {/* Project 3 Detail */}
        <article className="project-readme" id="project-terraform">
          <div className="readme-cmd">
            <span className="cmd-prompt">kartik@portfolio</span>
            <span className="cmd-path">:~/projects/Terraform-Multi-Env$</span> cat README.md
          </div>
          <div className="readme-content">
            <div className="readme-header">
              <h3><i className="fa-solid fa-layer-group"></i> Terraform Multi-Environment Deployment</h3>
              <div className="readme-badges">
                <span className="badge terraform">Terraform</span>
                <span className="badge infra">IaC</span>
                <span className="badge multi">Multi-Env</span>
              </div>
            </div>
            <div className="readme-body">
              <p className="readme-desc">Infrastructure provisioning across multiple environments (dev, stage, prod) using Terraform modules, variables, and backend configuration. Follows Infrastructure-as-Code principles for repeatable deployments.</p>
              <div className="readme-features">
                <span><i className="fa-solid fa-check"></i> Modular</span>
                <span><i className="fa-solid fa-check"></i> Reusable</span>
                <span><i className="fa-solid fa-check"></i> Scalable</span>
                <span><i className="fa-solid fa-check"></i> IaC</span>
              </div>
            </div>
            <div className="readme-links">
              <a href="https://github.com/KARTIKNAIK18/Terraform-mulit-env-deployment.git" target="_blank" rel="noopener noreferrer" className="readme-link code">
                <i className="fa-brands fa-github"></i> git clone
              </a>
            </div>
          </div>
        </article>
      </div>
      {/* More Projects Link */}
      <div className="more-projects-cmd">
        <span className="cmd-prompt">kartik@portfolio</span>
        <span className="cmd-path">:~/projects$</span> 
        <span>curl -s https://github.com/KARTIKNAIK18</span>    
        <a href="https://github.com/KARTIKNAIK18" target="_blank" rel="noopener noreferrer" className="more-link">
          <i className="fa-brands fa-github"></i> Explore more projects →
        </a>
      </div>
    </section>
  );
}